// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-details-wrapper {
    width: 100%;
    min-height: calc(100vh - 70px);
    background-color: var(--bg-app);
    padding: 30px 20px;
    display: flex;
    justify-content: center;
}

.match-details-container {
    width: 100%;
    max-width: 900px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.match-header {
    background: linear-gradient(135deg, var(--brand-primary) 0%, #1e293b 100%);
    color: white;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    padding: 40px 30px;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
    text-align: center;
    overflow: hidden;
}

.match-header::before {
    content: '';
    position: absolute;
    top: -50px;
    right: -50px;
    width: 200px;
    height: 200px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 50%;
    pointer-events: none;
}

.match-header::after {
    content: '';
    position: absolute;
    bottom: -30px;
    left: -30px;
    width: 150px;
    height: 150px;
    background: rgba(210, 248, 0, 0.05);
    border-radius: 50%;
    pointer-events: none;
}

.match-subtitle {
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--brand-accent);
    letter-spacing: 2px;
    margin: 0;
    opacity: 0.9;
    position: relative;
    z-index: 2;
}

.match-title {
    font-size: 2.5rem;
    font-weight: 800;
    color: white;
    margin: 0;
    line-height: 1.2;
    text-shadow: 0 2px 10px rgba(0,0,0,0.2);
    position: relative;
    z-index: 2;
}

.meta-row {
    display: flex;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;
    margin-top: 8px;
    position: relative;
    z-index: 2;
}

.meta-item {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 8px 16px;
    border-radius: 20px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.95rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
}

.meta-item i {
    color: var(--brand-accent);
}

.status-card {
    background-color: var(--bg-card);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    padding: 24px;
    border: 1px solid var(--border-light);
    border-left: 6px solid #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
}

.status-card.playing { border-left-color: #10B981; }
.status-card.available { border-left-color: var(--brand-accent); }
.status-card.unavailable { border-left-color: #94A3B8; }

.status-info h3 {
    margin: 0 0 8px 0;
    font-size: 1.1rem;
    color: var(--brand-primary);
}

.status-badge {
    display: inline-block;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 700;
    text-transform: uppercase;
}

.status-badge.playing { background: #DCFCE7; color: #166534; }
.status-badge.available { background: var(--brand-accent); color: var(--brand-primary); }
.status-badge.unavailable { background: #F1F5F9; color: #64748B; }

.status-actions {
    display: flex;
    gap: 12px;
}

.btn-action {
    border: none;
    padding: 10px 20px;
    border-radius: var(--radius-input);
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: var(--transition);
}

.btn-action.primary {
    background-color: var(--brand-accent);
    color: var(--brand-primary);
    box-shadow: 0 4px 10px rgba(210, 248, 0, 0.3);
}

.btn-action.danger {
    background-color: white;
    border: 1px solid #EF4444;
    color: #EF4444;
}

.btn-action:hover {
    transform: translateY(-2px);
    filter: brightness(0.95);
}

.btn-action:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.content-card {
    background-color: var(--bg-card);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-sm);
    padding: 24px;
    border: 1px solid var(--border-light);
}

.card-header {
    margin-bottom: 20px;
}

.card-header h2 {
    font-size: 1.25rem;
    color: var(--brand-primary);
    margin: 0 0 4px 0;
}

.card-header p {
    color: var(--text-muted);
    font-size: 0.9rem;
    margin: 0;
}

.players-section-title {
    font-size: 0.85rem;
    text-transform: uppercase;
    font-weight: 700;
    color: var(--text-muted);
    margin-bottom: 12px;
    display: block;
}

.players-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 24px;
}

.player-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px 6px 6px;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 500;
    background-color: var(--bg-app);
    border: 1px solid var(--border-light);
    color: var(--text-main);
}

.player-chip.selected {
    background-color: #F0FDF4;
    border-color: #BBF7D0;
    color: #166534;
}

.avatar-mini {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: #ccc;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 700;
}

.player-chip.selected .avatar-mini {
    background-color: #10B981;
}

.map-frame {
    width: 100%;
    height: 250px;
    border: none;
    border-radius: var(--radius-md) var(--radius-md) 0 0;
    display: block;
}

.map-footer {
    padding: 16px;
    background-color: var(--bg-app);
    border-radius: 0 0 var(--radius-md) var(--radius-md);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid var(--border-light);
    border-top: none;
}

.location-text {
    font-weight: 600;
    color: var(--text-main);
    display: flex;
    align-items: center;
    gap: 6px;
}

.btn-gps {
    background: white;
    border: 1px solid var(--border-light);
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 0.85rem;
    color: var(--text-main);
    text-decoration: none;
    font-weight: 600;
    transition: background 0.2s;
}

.btn-gps:hover {
    background-color: #F8FAFC;
    border-color: var(--brand-primary);
}

.loading-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    color: var(--text-muted);
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(0,0,0,0.1);
    border-top-color: var(--brand-accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin { to { transform: rotate(360deg); } }

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 12px;
    border-radius: var(--radius-md);
    text-align: center;
}

.admin-actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.btn-whatsapp {
    background-color: #25D366 !important;
    color: white !important;
    border: none !important;
}

.btn-close-match {
    background-color: #16a34a !important;
    color: white !important;
    border: none !important;
}

@media (max-width: 600px) {
    .card-header {
        flex-direction: column;
        align-items: flex-start !important;
        gap: 15px;
    }

    .admin-actions {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
    }

    .admin-actions .btn-action {
        width: 100%;
        padding: 10px 5px;
        font-size: 0.8rem;
        justify-content: center;
    }

    .admin-actions .btn-action span {

        display: inline-block;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MatchDayDetails.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,0EAA0E;IAC1E,YAAY;IACZ,+BAA+B;IAC/B,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,0CAA0C;IAC1C,iBAAiB;IACjB,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;IAC9B,aAAa;IACb,qCAAqC;IACrC,2BAA2B;IAC3B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA,uBAAuB,0BAA0B,EAAE;AACnD,yBAAyB,sCAAsC,EAAE;AACjE,2BAA2B,0BAA0B,EAAE;;AAEvD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,0BAA0B,+BAA+B,EAAE,2BAA2B,EAAE;AACxF,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;;AAEjE;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,oDAAoD;IACpD,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,oDAAoD;IACpD,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI;QACI,sBAAsB;QACtB,kCAAkC;QAClC,SAAS;IACb;;IAEA;QACI,WAAW;QACX,aAAa;QACb,8BAA8B;QAC9B,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA;;QAEI,qBAAqB;IACzB;AACJ","sourcesContent":[".match-details-wrapper {\n    width: 100%;\n    min-height: calc(100vh - 70px);\n    background-color: var(--bg-app);\n    padding: 30px 20px;\n    display: flex;\n    justify-content: center;\n}\n\n.match-details-container {\n    width: 100%;\n    max-width: 900px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.match-header {\n    background: linear-gradient(135deg, var(--brand-primary) 0%, #1e293b 100%);\n    color: white;\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    padding: 40px 30px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n    overflow: hidden;\n}\n\n.match-header::before {\n    content: '';\n    position: absolute;\n    top: -50px;\n    right: -50px;\n    width: 200px;\n    height: 200px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 50%;\n    pointer-events: none;\n}\n\n.match-header::after {\n    content: '';\n    position: absolute;\n    bottom: -30px;\n    left: -30px;\n    width: 150px;\n    height: 150px;\n    background: rgba(210, 248, 0, 0.05);\n    border-radius: 50%;\n    pointer-events: none;\n}\n\n.match-subtitle {\n    text-transform: uppercase;\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: var(--brand-accent);\n    letter-spacing: 2px;\n    margin: 0;\n    opacity: 0.9;\n    position: relative;\n    z-index: 2;\n}\n\n.match-title {\n    font-size: 2.5rem;\n    font-weight: 800;\n    color: white;\n    margin: 0;\n    line-height: 1.2;\n    text-shadow: 0 2px 10px rgba(0,0,0,0.2);\n    position: relative;\n    z-index: 2;\n}\n\n.meta-row {\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    flex-wrap: wrap;\n    margin-top: 8px;\n    position: relative;\n    z-index: 2;\n}\n\n.meta-item {\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(4px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    padding: 8px 16px;\n    border-radius: 20px;\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 0.95rem;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.meta-item i {\n    color: var(--brand-accent);\n}\n\n.status-card {\n    background-color: var(--bg-card);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    padding: 24px;\n    border: 1px solid var(--border-light);\n    border-left: 6px solid #ccc;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 20px;\n}\n\n.status-card.playing { border-left-color: #10B981; }\n.status-card.available { border-left-color: var(--brand-accent); }\n.status-card.unavailable { border-left-color: #94A3B8; }\n\n.status-info h3 {\n    margin: 0 0 8px 0;\n    font-size: 1.1rem;\n    color: var(--brand-primary);\n}\n\n.status-badge {\n    display: inline-block;\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 0.85rem;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n\n.status-badge.playing { background: #DCFCE7; color: #166534; }\n.status-badge.available { background: var(--brand-accent); color: var(--brand-primary); }\n.status-badge.unavailable { background: #F1F5F9; color: #64748B; }\n\n.status-actions {\n    display: flex;\n    gap: 12px;\n}\n\n.btn-action {\n    border: none;\n    padding: 10px 20px;\n    border-radius: var(--radius-input);\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: var(--transition);\n}\n\n.btn-action.primary {\n    background-color: var(--brand-accent);\n    color: var(--brand-primary);\n    box-shadow: 0 4px 10px rgba(210, 248, 0, 0.3);\n}\n\n.btn-action.danger {\n    background-color: white;\n    border: 1px solid #EF4444;\n    color: #EF4444;\n}\n\n.btn-action:hover {\n    transform: translateY(-2px);\n    filter: brightness(0.95);\n}\n\n.btn-action:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.content-card {\n    background-color: var(--bg-card);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-sm);\n    padding: 24px;\n    border: 1px solid var(--border-light);\n}\n\n.card-header {\n    margin-bottom: 20px;\n}\n\n.card-header h2 {\n    font-size: 1.25rem;\n    color: var(--brand-primary);\n    margin: 0 0 4px 0;\n}\n\n.card-header p {\n    color: var(--text-muted);\n    font-size: 0.9rem;\n    margin: 0;\n}\n\n.players-section-title {\n    font-size: 0.85rem;\n    text-transform: uppercase;\n    font-weight: 700;\n    color: var(--text-muted);\n    margin-bottom: 12px;\n    display: block;\n}\n\n.players-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-bottom: 24px;\n}\n\n.player-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 12px 6px 6px;\n    border-radius: 20px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    background-color: var(--bg-app);\n    border: 1px solid var(--border-light);\n    color: var(--text-main);\n}\n\n.player-chip.selected {\n    background-color: #F0FDF4;\n    border-color: #BBF7D0;\n    color: #166534;\n}\n\n.avatar-mini {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    background-color: #ccc;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.75rem;\n    font-weight: 700;\n}\n\n.player-chip.selected .avatar-mini {\n    background-color: #10B981;\n}\n\n.map-frame {\n    width: 100%;\n    height: 250px;\n    border: none;\n    border-radius: var(--radius-md) var(--radius-md) 0 0;\n    display: block;\n}\n\n.map-footer {\n    padding: 16px;\n    background-color: var(--bg-app);\n    border-radius: 0 0 var(--radius-md) var(--radius-md);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid var(--border-light);\n    border-top: none;\n}\n\n.location-text {\n    font-weight: 600;\n    color: var(--text-main);\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.btn-gps {\n    background: white;\n    border: 1px solid var(--border-light);\n    padding: 8px 12px;\n    border-radius: 8px;\n    font-size: 0.85rem;\n    color: var(--text-main);\n    text-decoration: none;\n    font-weight: 600;\n    transition: background 0.2s;\n}\n\n.btn-gps:hover {\n    background-color: #F8FAFC;\n    border-color: var(--brand-primary);\n}\n\n.loading-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 50vh;\n    color: var(--text-muted);\n}\n\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid rgba(0,0,0,0.1);\n    border-top-color: var(--brand-accent);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-bottom: 16px;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 12px;\n    border-radius: var(--radius-md);\n    text-align: center;\n}\n\n.admin-actions {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n}\n\n.btn-whatsapp {\n    background-color: #25D366 !important;\n    color: white !important;\n    border: none !important;\n}\n\n.btn-close-match {\n    background-color: #16a34a !important;\n    color: white !important;\n    border: none !important;\n}\n\n@media (max-width: 600px) {\n    .card-header {\n        flex-direction: column;\n        align-items: flex-start !important;\n        gap: 15px;\n    }\n\n    .admin-actions {\n        width: 100%;\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 8px;\n    }\n\n    .admin-actions .btn-action {\n        width: 100%;\n        padding: 10px 5px;\n        font-size: 0.8rem;\n        justify-content: center;\n    }\n\n    .admin-actions .btn-action span {\n\n        display: inline-block;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
